<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            <span>KVKK Onay Listesi</span>
        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col class="margin-bottom-10" :span="24">
                <div class="aciklamaListesi">
                    <ul>
                        <li class="renk-detay"><i class="mdi mdi-reload"></i> Doğrulama Kodu Gönder</li>
                        <li class="renk-tamamlandi"><i class="mdi mdi-check"></i> KVKK Doğrula</li>
                    </ul>
                </div>
            </el-col>
            <el-table
                    v-loading="loading"
                    :data="kvkkListesi"
                    ref="filterTable"
                    border
                    stripe
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        sortable
                        label="İsim Soyisim"
                        width="auto">
                    <template slot-scope="scope">
                        {{kategori === '1' ? scope.row.hastaDis[0].adSoyad : scope.row.hastaOrtopedi[0].adSoyad}}
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="kategori === '1'"
                        label="T.C."
                        width="200">
                    <template slot-scope="scope">
                        {{scope.row.hastaDis[0].tcNo}}
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="kategori === '2'"
                        label="Bilgi Adı"
                        width="200">
                    <template slot-scope="scope">
                        {{scope.row.hastaOrtopedi[0].bilgiAdi}}
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="kategori === '2'"
                        label="Bilgi"
                        width="200">
                    <template slot-scope="scope">
                        {{scope.row.hastaOrtopedi[0].bilgi}}
                    </template>
                </el-table-column>

                <el-table-column
                        label="Yaş"
                        width="100">
                    <template slot-scope="scope">
                        {{kategori === '1' ? scope.row.hastaDis[0].yas : scope.row.hastaOrtopedi[0].yas}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Telefon No:"
                        width="200">
                    <template slot-scope="scope">
                        {{kategori === '1' ? scope.row.hastaDis[0].telefon : scope.row.hastaOrtopedi[0].telefon}}
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        label="Kayıt Tarihi"
                        width="200">
                    <template slot-scope="scope">
                        {{kategori === '1' ? scope.row.hastaDis[0].kayitTarihi : scope.row.hastaOrtopedi[0].kayitTarihi}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="250">
                    <!--<template slot="header" slot-scope="scope">-->
                        <!--<el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"-->
                                  <!--placeholder="Ara" size="mini"></el-input>-->
                    <!--</template>-->
                    <template slot-scope="scope">
                        <el-tooltip content='Kod Gönder' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #0075c3"
                                       class="buttonEdit"
                                       v-on:click="dogrulamaKoduGonder(scope.row)"
                                       icon="mdi mdi-reload" type="text"></el-button>
                        </el-tooltip>
                        <el-tooltip content='Doğrula' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #13ce66"
                                       class="buttonEdit"
                                       v-on:click="dogrulamaKoduVisible = true; telefon = scope.row.hastaDis[0].telefon; dogrulamaKodu=''; hastaId = scope.row.hastaId"
                                       icon="mdi mdi-check" type="text"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="margin-top-20"
                    v-if="surecVisible"
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
            <div style="font-style: italic" v-else>
                Aramış olduğunuz kritere uygun " {{search}} " veriler listelenmektedir. <br> Listeyi sıfırlamak için
                " <i class="mdi mdi-close-circle-outline"></i> " butonunu kullanabilirsiniz.
            </div>
        </div>
        <el-dialog
                :close-on-press-escape="false"
                title='Doğrulama Kodu Kontrol'
                :visible.sync="dogrulamaKoduVisible"
                append-to-body
                width="40%"
                class="klinikModal"
                center>
            <span>
                <el-row>
                    <el-col :lg="24" :md="24" :sm="24" :xs="24">
                        <el-input
                                v-model="dogrulamaKodu"
                                filterable
                                placeholder='Doğrulama Kodu Giriniz'
                                style="width: 100%"></el-input>
                    </el-col>
                </el-row>
            </span>

            <span slot="footer" class="dialog-footer">
                <el-button class="margin-bottom-50 estas-buton ileriButton"
                           size="small"
                           type="primary"
                           style="margin:0"
                           @click="dogrulamaKontrol">
                        Kaydet
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                            <path fill="#fff" d="M9 22l-10-10.598 2.798-2.859 7.149 7.473 13.144-14.016 2.909 2.806z"/>
                        </svg>
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    import EventBus from '@/components/event-bus'

    import kvkkService from '../../../WSProvider/KvkkService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import JQuery from 'jquery';
    import Vue from 'vue'
    import excel from 'vue-excel-export'

    Vue.use(excel)
    let $ = JQuery;
    let base64 = require('base64_js');
    let userData3H = "";
    export default {
        name: "KvkkListesi",
        mounted() {
            let self = this;
            if (localStorage.getItem("userData3H")) {
                userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["tur"]) {
                    if (userData3H["tur"] === '1') {
                        self.root = true;
                    } else if (userData3H["tur"] === '2') {
                        self.yetkili = true;
                    }
                }
            }
            this.getKvkkCount();
            this.getKvkkList();

            this.kategori = userData3H['kategori']

        },
        data() {
            return {
                dogrulamaKoduVisible: false,
                dogrulamaKodu: '',
                excelTable: [],
                kvkkListesi: [],
                page: 0,
                sizes: 20,
                postPage: 0,
                total: null,
                filterDialogVisible: false,
                surecVisible: true,
                root: false,
                yetkili: false,
                search: '',
                kategori: '',
                telefon: '',
                hastaId: '',
                loading: true
            }
        },
        methods: {
            searchMethod(val) {
                console.log(val)
                this.kvkkListesi = [];
                var dizi = [];
                if (val !== '') {
                    kvkkService.kvkkSearch(val).then((response) => {
                        if (response.status === 200) {
                            this.surecVisible = false;
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            console.log(dizi)
                            console.log(this.kvkkListesi)
                            this.kvkkListesi = dizi;
                            console.log(this.kvkkListesi)
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.surecVisible = true;
                this.kvkkListesi = [];
                this.getKvkkList();
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getKvkkList();
            },
            getKvkkCount() {
                kvkkService.kvkkCount(0).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data.count);
                    }
                });
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getKvkkList();
            },
            getKvkkList() {
                let self = this;
                self.kvkkListesi = [];
                kvkkService.kvkkListe(this.postPage, this.sizes, "0").then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            if (userData3H['kategori'] === '1' && e.hastaDis.length > 0) {
                                self.kvkkListesi.push(e)
                            } else if (userData3H['kategori'] === '2' && e.hastaOrtopedi.length > 0) {
                                self.kvkkListesi.push(e)
                            }
                        });
                        this.loading = false;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            dogrulamaKontrol() {
                kvkkService.kvkkOnayTelefon(this.telefon,this.hastaId, this.dogrulamaKodu).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Hastaya ait KVKK durumu onaylandı.');
                        this.dogrulamaKodu = '';
                        this.telefon = '';
                        this.dogrulamaKoduVisible = false;
                        this.kvkkListesi.splice(index, 1);
                    } else if (response.status === 410) {
                        notification.Status('warning', this, 'Doğrulama kodu hatalı!');
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            dogrulamaKoduGonder(val) {

                kvkkService.kvkkKodGonder(val.hastaDis[0].telefon,val.hastaId ? val.hastaId : 0,this.kategori).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Hastaya doğrulama mesajı gönderildi.');
                    } else notification.Status(response.status, this)
                })
            }
        }
    }

</script>
<style lang="scss" scoped>
    .durum {
        position: relative;
        bottom: 3px;
    }

    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: scale(1.5, 1.5);
    }

    .el-pagination {
        float: right;
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 5px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .reddedilen .el-badge__content {
        background-color: #af0800;
        z-index: 1;
        right: 20px;
    }

    .onay .el-badge__content {
        background-color: #f7ba2a;
        z-index: 1;
        right: 20px;
    }

    .islemde .el-badge__content {
        background-color: #00bcd0;
        z-index: 1;
        right: 20px;
    }

    .silinen .el-badge__content {
        background-color: #ec205f;
        z-index: 1;
        right: 20px;
    }

    .randevu .el-badge__content {
        background-color: #6a3ab0;
        z-index: 1;
        right: 20px;
    }

    .doktoronay .el-badge__content {
        background-color: #f2de59;
        z-index: 1;
        right: 20px;
    }

    .uretim .el-badge__content {
        background-color: #ff9632;
        z-index: 1;
        right: 20px;
    }

    .sinterleme .el-badge__content {
        background-color: #f43131;
        z-index: 1;
        right: 20px;
    }

    .polisaj .el-badge__content {
        background-color: #f43131;
        z-index: 1;
        right: 20px;
    }

    .doktoronay2 .el-badge__content {
        background-color: #a027a8;
        z-index: 1;
        right: 20px;
    }

    .depo .el-badge__content {
        background-color: #0075c3;
        z-index: 1;
        right: 20px;
    }

    .kargo .el-badge__content {
        background-color: rgba(0, 117, 195, 0.41);
        z-index: 1;
        right: 20px;
    }

    .tamamlanan .el-badge__content {
        background-color: #13ce66;
        z-index: 1;
        right: 20px;
    }

    .hatali .el-badge__content {
        background-color: black;
        z-index: 1;
        right: 20px;
    }

    .not:hover {
        cursor: pointer;
    }

</style>
<style scoped>

    .hastaKabulBaslik {
        display: flex;
        justify-content: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
    }

    .hastaKabulBaslik h1 {
        background: #161c3c;
        color: #fff;
        font-weight: 700;
        padding: 8px 20px;
        position: relative;
    }

    .hastaKabulFormu {
        position: relative;
        z-index: 10;
    }

    .formBilgileri {
        display: flex;
    }

    .ozel-sagayasla {
        float: right;
    }

    .formBilgiBaslik {
        writing-mode: tb-rl;
        transform: rotate(180deg);
        float: left;
        text-align: center;
        background: #161c3c;
        color: #fff;
        padding: 12px 2px;
        text-transform: uppercase;
        font-weight: 600;
        position: relative;
        min-height: 190px;
    }

    .mobil-baslik {
        display: none;
        text-align: center;
        background: #161c3c;
        padding: 5px 2px;
        text-transform: uppercase;
        font-weight: 600;
        width: 100%;
        color: #fff;
    }

    .formElemanlari {
        padding: 0 20px !important;
    }

    .input-effect {
        position: relative;
        display: flex;
        align-items: flex-start;
    }

    .input-effect .formBilgi {
        height: 100%;
        padding: 10px 10px 0;
        font-size: 14px;
        font-weight: 500;
        flex-shrink: 0;
        min-width: 90px;
    }


    .yazdir-bilgisi {
        font-size: 14px;
        padding: 5px;
    }

    .effect-7, .effect-8, .effect-9 {
        border: 1px solid transparent;
        padding: 10px 10px 0;
        transition: .4s;
        width: 100%;
    }

    .formBilgiBaslik.sagTaraf {
        transform: none;
    }

    .formBilgiBaslik:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 27px;
        transform: translate(0, -50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 10px 0;
        border-color: transparent #161c3c transparent transparent;
    }

    .grupBilgisi {
        background: linear-gradient(90deg, rgba(22, 28, 60, 0) 5%, rgba(22, 28, 60, 0.5) 25%, rgba(22, 28, 60, 1) 40%, rgba(22, 28, 60, 1) 60%, rgba(22, 28, 60, 0.5) 75%, rgba(22, 28, 60, 0) 95%);
        font-size: 14px;
        font-weight: 500;
        padding: 8px 6px;
        text-align: center;
    }

    .grupBilgisi p {
        margin: 0;
        color: #fff;
    }

    .disOpsiyonlari {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        width: 100%;
        padding-top: 10px;
        page-break-inside: avoid;
        justify-content: start;
    }

    .yazdirFormSayfa .disNumarasi-yazdir {
        border-bottom: 1px solid #eee;
    }


    .randevular .opsiyonDiv {
        padding: 6px 5px;
        width: 15%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }

    .opsiyonDiv {
        padding: 6px 5px;
        width: 11%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }


    .doktor-bilgi {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }


    .opsiyonDiv:before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        right: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }


    .opsiyonDiv:nth-child(1):after {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        left: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disler-arasi-cizgi {
        height: 2px;
        width: 95%;
        position: relative;
        left: 50%;
        transform: translateX(calc(-50% + -27px));
        margin: 8px 0;
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disNumarasi-yazdir div:first-child {
        color: #3cbcb4;
        text-transform: uppercase;
    }

    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .disNumarasi-yazdir div:last-child {
        font-weight: 700;
    }

    .disNumarasi-yazdir div:last-child span {
        padding: 3px 7px;
        border: 1px solid #00bcb4;
        color: #0a716b;
        display: inline-block;
    }


    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .ozel-row {
        display: flex;
        justify-content: center;
    }

    @media only screen and (max-width: 480px) {
        .opsiyonDiv:nth-child(1):after,
        .opsiyonDiv:nth-child(3):after,
        .opsiyonDiv:nth-child(5):after,
        .opsiyonDiv:nth-child(7):after {
            content: "";
            position: absolute;
            width: 2px;
            height: 100%;
            left: 0;
            top: 0;
            background: #3cbcb4;
            background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
            background: linear-gradient(transparent, #3cbcb4, transparent);
        }

        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 60px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 86px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }
</style>